export default __webpack_public_path__ + "static/media/IR.2dc8cb17.ico";